import * as React from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function HeroArtwork() {
  return <section id="hero-artwork" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/screenshot_2026_05_12_at_10_26_27_am.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/screenshot_2026_05_12_at_10_26_27_am.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/screenshot_2026_05_12_at_10_26_27_am.png-wvc-sizes" alt="" className="w-full h-full object-cover blur-xl opacity-40 scale-110" aria-hidden="true" loading="lazy" />
        {}
        <div className="absolute inset-0 bg-background/60 backdrop-blur-md" />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary/20 to-transparent" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 py-24 flex flex-col items-center text-center">
        {}
        <div className="mb-10 md:mb-14 relative group">
          <div className="absolute -inset-2 bg-gradient-to-tr from-primary/50 to-secondary/50 rounded-lg blur-xl opacity-50 group-hover:opacity-70 transition-opacity duration-700"></div>
          <img src="https://electric-cat.10web.cloud/wp-content/uploads/2026/05/Screenshot-2026-05-12-at-10.26.27-AM.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/screenshot_2026_05_12_at_10_26_27_am.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/screenshot_2026_05_12_at_10_26_27_am.png-wvc-sizes" alt="Glamour Kitty Album Artwork" className="relative w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 object-cover rounded-md" loading="lazy" />
        </div>

        {}
        <div className="flex flex-col items-center max-w-4xl mx-auto">
          <p className="text-lg md:text-xl font-medium text-muted-foreground mb-4 uppercase tracking-[0.2em]">
            Yoga Dinners
          </p>
          <h1 className="font-default text-6xl md:text-8xl lg:text-[9rem] font-bold text-foreground mb-12 tracking-tighter leading-none drop-shadow-sm">
            GLAMOUR KITTY
          </h1>
        </div>

        {}
        
      </div>
    </section>;
}